import React from 'react';

export default function Message({ message }) {
  const isUser = message.role === 'user';
  return (
    <div className={`d-flex mb-3 ${isUser ? 'justify-content-end' : 'justify-content-start'}`}>
      <div className={`p-3 rounded ${isUser ? 'bg-primary text-white' : 'bg-light border'}`} style={{ maxWidth: '70%' }}>
        {message.content.map((c, idx) => (
          <div key={idx}>{c.text.value}</div>
        ))}
      </div>
    </div>
  );
} 